import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

type BoardBadgeProps = {
  badge: string;
  text: string;
  icon: string;
};

const BoardBadge: FC<BoardBadgeProps> = ({ badge, text, icon }) => {
  const { t } = useTranslate();
  const badgeClass = 'badge badge-pill badge-sm';

  return (
    <span className={`${badgeClass} ${badge}`}>
      <em className={`icon mr-1 ${icon}`} />
      {t(text)}
    </span>
  );
};

export default BoardBadge;
